import {Field} from 'formik';

import {
    FormikSelect,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Tabs} from '@mantine/core';
import {CodeRepositoriesAutocomplete} from '../../code-repositories/inputs/CodeRepositoriesAutocomplete';
import {DeploymentAccountGroupsAutocomplete} from '../../deployment-account-groups/inputs/DeploymentAccountGroupsAutocomplete';
import {PipelineStagesEditor} from '../components/PipelineStagesEditor';
import {DeploymentAccountsEditor} from '../components/DeploymentAccountsEditor';


export const FormComponent = () => {

    return (
        <Tabs defaultValue={'details'}>
            <Tabs.List>
                <Tabs.Tab value='details'>Details</Tabs.Tab>
                <Tabs.Tab value='repository'>Repository</Tabs.Tab>
                <Tabs.Tab value='stages'>Stages</Tabs.Tab>
                <Tabs.Tab value='accounts'>Deployment Accounts</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value='details' pt='xl'>
                <PlatformFieldset legend={'Pipeline Details'}>
                    <Field
                        name='name'
                        label='Name'
                        description='Please enter the pipeline name'
                        component={FormikTextInput}
                        withAsterisk
                        my={'xl'}
                    />

                    <Field
                        name='description'
                        label='Description'
                        description='Please enter pipeline description'
                        component={FormikTextarea}
                        my={'xl'}
                    />

                    <Field
                        name='pipelineType'
                        label='Pipeline Type'
                        description='Please select the pipeline type'
                        component={FormikSelect}
                        data={[
                            {value: 'APPLICATION', label: 'Application'},
                            {value: 'API', label: 'API'},
                            {value: 'DATABASE', label: 'Database'},
                            {value: 'INFRASTRUCTURE', label: 'Infrastructure'},
                            {value: 'LIBRARY', label: 'Library'},
                            {value: 'SERVICE', label: 'Service'},
                        ]}
                        withAsterisk
                        my={'xl'}
                    />

                    <Field
                        name='buildCommand'
                        label='Build Command'
                        description='Please enter the build command'
                        component={FormikTextInput}
                        my={'xl'}
                    />

                    <Field
                        name='pipelineStatus'
                        label='Status'
                        description='Pipeline status'
                        component={FormikSelect}
                        data={[
                            {value: 'CREATING', label: 'Creating'},
                            {value: 'ACTIVE', label: 'Active'},
                            {value: 'UPDATING', label: 'Updating'},
                            {value: 'FAILED', label: 'Failed'},
                            {value: 'DELETING', label: 'Deleting'},
                            {value: 'ARCHIVED', label: 'Archived'},
                            {value: 'IMPORTED', label: 'Imported'},
                            {value: 'MIGRATING', label: 'Migrating'},
                            {value: 'MIGRATED_PENDING_CLEANUP', label: 'Migrated Pending Cleanup'},
                        ]}
                        my={'xl'}
                    />

                </PlatformFieldset>
            </Tabs.Panel>

            <Tabs.Panel value='repository' pt='xl'>
                <PlatformFieldset legend={'Repository'}>
                    <Field
                        name='codeRepositoryName'
                        label='Code Repository'
                        description='Please select the code repository'
                        component={CodeRepositoriesAutocomplete}
                        withAsterisk
                        my={'xl'}
                    />
                    <Field
                        name='branchName'
                        label='Branch Name'
                        description='Please enter the branch name'
                        component={FormikTextInput}
                        my={'xl'}
                    />
                </PlatformFieldset>
            </Tabs.Panel>

            <Tabs.Panel value='stages' pt='xl'>
                <PipelineStagesEditor/>
            </Tabs.Panel>

            <Tabs.Panel value='accounts' pt='xl'>
                <PlatformFieldset legend={'Deployment'}>
                    <Field
                        name='deploymentAccountGroupId'
                        label='Account Group'
                        description='Please select the deployment account group'
                        component={DeploymentAccountGroupsAutocomplete}
                        my={'xl'}
                    />
                </PlatformFieldset>

                <DeploymentAccountsEditor/>
            </Tabs.Panel>
        </Tabs>
    );
};
